import React from 'react';
import { connect } from 'redux-bundler-react';
import { SidebarButton } from '../../application-controls/index';
import { transform } from 'ol/proj';

class ZoomHomeButton extends React.Component {
  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(){
    const { geoProjection, doZoomToLocation, defaultConfig } = this.props;
    const { centerX, centerY, centerZ } = defaultConfig.map;
    const center = transform(
      [Number(centerX), Number(centerY)],
      geoProjection,
      'EPSG:3857'
    );
    doZoomToLocation(center, centerZ);
  }

  render() {
    return (
      <SidebarButton
        iconClass="mdi mdi-home"
        label="Zoom to initial extent"
        title="Zoom to initial extent"
        onClick={ this.handleClick }
      />
    );
  }
}

export default connect(
  'selectDefaultConfig',
  'selectGeoProjection',
  'doZoomToLocation',
  ZoomHomeButton
);